// Transformes the ReactComponent Child to the ParsedElement data representation
export const parseChild = (child, filter, searchString, favorites, index) => {
  const label = child.props?.label ?? '';
  const id = child.key ?? index;
  const hasSearchString = !!searchString;
  const isExactMatch = searchString === label;
  const isCategory = child?.type?.displayName === 'DropdownCategory';
  if (isCategory) {
    return {
      id,
      label,
      type: 'CATEGORY',
      filtered: hasSearchString
    };
  }
  const isFavorite = favorites.includes(id);
  const isFiltered = !filter?.(searchString ?? '', child) && hasSearchString && !isExactMatch || isFavorite && !hasSearchString;
  return {
    id,
    label,
    type: 'OPTION',
    filtered: isFiltered,
    disabled: !!child.props?.disabled
  };
};